export enum EnumAlertaNivel {
    'Informação' = 1,
    Alerta = 2,
    Grave = 3,
    'Crítico' = 4
}
